<template>
  <div class="reportStepWrapper">
    <PowerbiReport
    v-if="reportId"
      :reportId="reportId"
      :workspaceId="workspaceId"
      :showLoading="false"
      :fitToWidth="shouldFitToWidth"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PowerbiReport from "@/components/PowerbiReport";

export default {
  data() {
    return {
      workspaceId: "",
      reportId: "",
      cockpitReport: null,
    };
  },
  components: { PowerbiReport },
  methods: {},
  computed: {
    ...mapGetters({
      reportDetails: "powerBi/reportDetails",
    }),
    shouldFitToWidth() {
      // Cockpit report
      return this.reportId === "39690035-ee3c-421b-b868-aeb8dbe6b7f2";
    }
  },
  async created() {},
  async mounted() {
    const cockpitReportId = this.$route.params.id;
    console.log("Loading 1 report for ", cockpitReportId);
    this.workspaceId = "afa6e1f5-c992-4df0-b26d-ae60217b531d"; // TODO
    this.reportId = cockpitReportId;
  },
};
</script>

<style lang="scss" scoped>
.reportStepWrapper {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;

/*   #powerbi-wrapper {
    aspect-ratio: 4/3;
    max-width: 100%;
  } */
}
</style>